import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

type Props = {
  /** Downloadable URL of icon */
  url: string;
};

export function CustomBotIcon({ url }: Props) {
  return (
    <SlideUpImage
      id="custom-chat-icon"
      loading="eager" // important for user to see ASAP
      src={url}
      alt="Chat Icon"
      height="100%"
      width="100%"
    />
  );
}

const slideUp = keyframes`
  0% {
    transform: translateY(4px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const SlideUpImage = styled.img`
  animation: ${slideUp} 1s ease-out forwards;
`;
